(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabbed-recommendations"] && !window.DesignMode) return;
  try {
    
  const recoActiveClass = 'active';
  let recoTabs = document.querySelector('.tabbed-module');
  let recoTitles = recoTabs.querySelectorAll('.tabbed-title-wrap .tabbed-title');

  let clickHandler = function (e) {
     e.preventDefault();
     const self = this;
     const tabChangeEvent = new Event('tabChange');
     const tabTitle = this;
     const tabTitleWrap = tabTitle.closest('.tabbed-title-wrap');
     const tabContentTarget = tabTitle.dataset.target;
     console.log('tabContentTarget', tabContentTarget);
     if (tabTitle.classList.contains(recoActiveClass)) return;
     const activeTab = tabTitleWrap.querySelector('.tabbed-title.active');
     if (activeTab) activeTab.classList.remove(recoActiveClass);
     tabTitle.classList.add(recoActiveClass);
     if (self.onTabSelect) {
         self.onTabSelect.call(tabTitle);
         return;
     }
     const tabContentWrap = tabTitleWrap.parentNode.querySelector('.tabbed-content-wrap');
     tabContentWrap.querySelectorAll('.tabbed-content').forEach(content => {
         content.classList.remove(recoActiveClass);
     });
     const targetContent = tabContentWrap.querySelector(`.tabbed-content[data-target="${tabContentTarget}"]`);
     if (targetContent) targetContent.classList.add(recoActiveClass);
     tabTitle.dispatchEvent(tabChangeEvent);
  };

  recoTitles.forEach(tabTitle => {
      tabTitle.addEventListener('click', clickHandler);
  });
  

  } catch(e) { console.error(e); }
})();
})();
